function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint semi: ["error", "never"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import Button from '@engine/components/presentational/base/button';
import React from 'react';
var RESET_STATE_TIMEOUT = 3000;

var CopyContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(CopyContainer, _React$Component);

  var _super = _createSuper(CopyContainer);

  function CopyContainer(props) {
    var _this;

    _classCallCheck(this, CopyContainer);

    _this = _super.call(this, props);
    _this.initialState = {
      icon: 'copy',
      text: ''
    };
    _this.state = _this.initialState;
    _this.targetTextInput = React.createRef();
    _this.timer = null;
    return _this;
  }
  /**
   * Component life cycle
   */


  _createClass(CopyContainer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(_prevProps, prevState) {
      if (prevState.text !== this.initialState.text) {
        clearTimeout(this.timer);
      }
    }
    /**
     * Render component
     */

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement(React.Fragment, null, this.alignButtonRight && this.renderTargetText(), React.createElement(Button, {
        className: "copy-btn mr-5",
        onClick: function onClick() {
          return _this2.copy();
        },
        icon: this.state.icon,
        size: "xs"
      }, this.state.text, React.createElement("input", {
        type: "text",
        style: {
          position: 'fixed',
          left: '-9999px',
          top: '-9999px'
        },
        defaultValue: this.target,
        ref: this.targetTextInput
      })), this.alignButtonLeft && this.renderTargetText());
    }
    /**
     * Private methods
     */

  }, {
    key: "copy",
    value: function copy() {
      try {
        if (navigator.clipboard) {
          navigator.clipboard.writeText(this.target);
        } else {
          this.copyToClipboard();
        }

        this.setState(_objectSpread(_objectSpread({}, this.state), {}, {
          icon: 'ok'
        }));
      } catch (e) {
        this.setState({
          icon: 'remove',
          text: I18n.t('javascript.errors.copy_fail')
        });
      }

      this.resetToInitialState();
    }
  }, {
    key: "copyToClipboard",
    value: function copyToClipboard() {
      this.targetTextInput.current.select();
      document.execCommand('copy');
    }
  }, {
    key: "resetToInitialState",
    value: function resetToInitialState() {
      var _this3 = this;

      this.timer = setTimeout(function () {
        _this3.setState(_this3.initialState);
      }, RESET_STATE_TIMEOUT);
    }
  }, {
    key: "renderTargetText",
    value: function renderTargetText() {
      var visibility = this.props.target_visibility ? '' : 'hidden';
      var spacing = this.alignButtonRight ? 'mr-5' : '';
      return React.createElement("span", {
        className: "".concat(visibility, " ").concat(spacing)
      }, this.target);
    }
    /**
     * Computed properties
     */

  }, {
    key: "target",
    get: function get() {
      return _typeof(this.props.target) === 'object' ? JSON.stringify(this.props.target) : this.props.target;
    }
  }, {
    key: "alignButtonLeft",
    get: function get() {
      return this.props.alignButton === 'left';
    }
  }, {
    key: "alignButtonRight",
    get: function get() {
      return this.props.alignButton === 'right';
    }
  }]);

  return CopyContainer;
}(React.Component);

CopyContainer.defaultProps = {
  target_visibility: true,
  alignButton: 'left'
};
export default CopyContainer;